import { JSX, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import moment, { Moment } from 'moment-timezone'
import { RegularCancellationRequest, RequestSlot } from '@/types/Slots.ts'

export function useTimeDifference(request: RegularCancellationRequest | RequestSlot): JSX.Element {
    const { t } = useTranslation()

    const { days, hoursRemaining, minutesRemaining } = useMemo(() => {
        const requestDateMoment: Moment = moment(request.requestDate, 'DD-MM-YYYY HH:mm:ss')
        const dateMoment: Moment = moment(
            moment(request.date, 'DD-MM-YYYY').format('DD-MM-YYYY') +
                ' ' +
                moment(request.start, 'HH:mm:ss').format('HH:mm:ss'),
            'DD-MM-YYYY HH:mm:ss'
        )

        const diff: number = dateMoment.diff(requestDateMoment, 'minutes')

        return {
            days: Math.floor(diff / 1440),
            hoursRemaining: Math.floor((diff % 1440) / 60),
            minutesRemaining: Math.floor((diff % 1440) % 60)
        }
    }, [request.requestDate, request.date, request.start])

    return (
        <>
            {days > 0 && (
                <>
                    {days} {days > 1 ? t('days') : t('day')}
                </>
            )}
            {hoursRemaining > 0 ? (
                <>
                    {days > 0 && <> {t('and').toLowerCase()} </>}
                    {hoursRemaining} {hoursRemaining > 1 ? t('hours') : t('hour')}
                </>
            ) : (
                <>
                    {minutesRemaining} {minutesRemaining > 1 ? t('minutes') : t('minute')}
                </>
            )}{' '}
            {t('before').toLowerCase()}
        </>
    )
}
